<template>

<Dialog :visible="visibility" modal :closable="false" header="Add item details" :style="{ width: '130rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

  <div class="grid">
      <div class="surface-50 shadow-2 p-3 border-round-xl w-full mt-4 mx-2 h-full">
        <div class="grid nested-grid">
          <div class="col-8">
            <div class="grid">
              <div class="field col-5">
                <label class="font-semibold">Item</label>
                <div>
                  <InputText class="w-full" v-model="itemName" placeholder="Enter Item" ></InputText>
                  <div>
                    <small id="item-qty-help" >Order Qty:</small><small class="font-semibold">{{ itemQty }}</small>
                  </div>
                  
                </div>
              </div>
              <div class="field col">
                <label class="font-semibold">HSN</label><span class="text-red-500">*</span>
                <div>
                  <InputText class="w-full" v-model="itemHsn"  placeholder="HSN/SAC code" ></InputText>
                </div>
              </div>
              <div class="field col">
                <label class="font-semibold">Recd Qty<span class="text-red-500">*</span></label>
                <div>
                  <InputNumber class="w-full" v-model="recdQty" @input="setRecdQty"></InputNumber>
                  <!-- <small id="item-qty-help" class="font-semibold">Total Quantity received</small> -->
                  <div>
                    <small id="item-qty-help" >Dispatched Qty:</small><small class="font-semibold">{{ item.arrived.quantity }}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="grid">
              <div class="col-5">
                <Button v-if="invoiceItem?.category=='Equipment' || invoiceItem?.category=='EQUIPMENT'" icon="pi pi-plus" label="Add Parts" size="small" raised @click="addPart"></Button>

                <Button v-else icon="pi pi-plus" label="Add Batch" size="small" raised @click="addBatch"></Button>
              </div>
              <div v-if="invoiceItem?.category=='Equipment' || invoiceItem?.category=='EQUIPMENT'" class="col">
                <label class="font-semibold">Batch</label>
                <div>
                  <InputText class="w-full" v-model="itemBatch" placeholder="Batch No." ></InputText>
                </div>
              </div>

              <div v-if="invoiceItem?.category!=='Equipment' || invoiceItem?.category!=='EQUIPMENT'" class="col">
                <label  class="font-semibold">Packing<span class="text-red-500">*</span></label>
                  <div>
                    <InputText class="w-full" v-model="itemPacking" placeholder="Packing Unit" ></InputText>
                  </div>
              </div>

              <div v-if="invoiceItem?.category=='Equipment' || invoiceItem?.category=='EQUIPMENT'" class="col">
                <label  class="font-semibold">Model No.</label>
                <div>
                  <InputText v-if="invoiceItem?.category=='Equipment' || invoiceItem?.category=='EQUIPMENT'" class="w-full" v-model="itemModelNo" placeholder="Model No." ></InputText>
                </div>
              </div>
              <div class="col">
                <label v-if="invoiceItem?.category=='Equipment' || invoiceItem?.category=='EQUIPMENT'" class="font-semibold">Part/Sr No.</label>
                <div>
                  <InputText v-if="invoiceItem?.category=='Equipment' || invoiceItem?.category=='EQUIPMENT'" class="w-full" v-model="itemPartSerialNo" placeholder="Part or Serial No." ></InputText>
                </div>
              </div>
            </div>

          </div>

          <div class="col-4">
            <div class="grid">
              <div class="field col">
                <label class="font-semibold">Rate<span class="text-red-500">*</span></label>
                <div>
                  <InputNumber  v-model="itemRate" :minFractionDigits="4" :maxFractionDigits="4" @input="setRate" ></InputNumber>
                </div>
              </div>
              <div class="field col">
                <label class="font-semibold">Ex-GST</label>
                <div>
                  <label >{{ itemExGst }}</label>
                </div>
              </div>
              <div class="field col">
                <label class="font-semibold">Total</label>
                <div>
                  <label >{{ itemTotal }}</label>
                </div>
              </div>

            </div>
            
            <div class="grid">
              <div class="field col">
                <label class="font-semibold">GST(%)<span class="text-red-500">*</span></label>
                  <div>
                    <InputNumber  v-model="itemGstRate" :minFractionDigits="2" :maxFractionDigits="2" @input="setGst"></InputNumber>
                  </div>
              </div>
              <div class="field col">
                <label class="font-semibold">GST</label>
                  <div>
                    <label >{{ itemGst }}</label>
                  </div>
              </div>
              <div class="field col">
                <div>
                  <!-- <Button icon="pi pi-trash" severity="danger" raised text @click="removeItem"></Button> -->
                </div>
              </div>
            </div>
            
            <div class="grid">
              <div class="field col">
                <label class="font-semibold">Disc(%)</label>
                  <div>
                    <InputNumber  v-model="itemDiscRate" :minFractionDigits="2" :maxFractionDigits="2" @input="setDiscount" ></InputNumber>
                  </div>
              </div>
              <div class="field col">
                <label class="font-semibold">Discount</label>
                  <div>
                    <label >{{ itemDiscAmt }}</label>
                  </div>
              </div>
              <div class="field col">
                <div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-5" v-if="batchArr.length>0 || equipmentPartsArr.length>0">
          <Divider></Divider>
        </div>

        <!-- if non equipment -->
        <div class="grid nested-grid ml-4">
          <div class="grid" v-for="(item, index) in batchArr" :key="index">
            <div class="field col">
              <label class="font-semibold">Quantity<span class="text-red-500">*</span></label>
              <div>
                <InputNumber v-model="item.quantity" @update:modelValue="batchValue(index)"></InputNumber>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Batch</label>
              <div>
                <InputText class="w-full" v-model="item.batch" ></InputText>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Mfg</label>
              <div>
                <Calendar v-model="item.mfg" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" ></Calendar>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Exp</label>
              <div>
                <Calendar v-model="item.exp" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" ></Calendar>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Rate</label>
              <div>
                 <label >{{ item.rate }}</label>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">GST(%)</label>
              <div>
                 <label >{{ item.gstRate }}</label>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Disc(%)</label>
              <div>
                 <label >{{ item.discPerc }}</label>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Disc</label>
              <div>
                 <label >{{ item.discAmt }}</label>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Subtotal</label>
              <div>
                 <label >{{ item.subTotal }}</label>
              </div>
            </div>

            <div class="field col">
              <div>
                <Button icon="pi pi-trash" severity="danger" raised text @click="removeBatch(index)"></Button>
              </div>
            </div>
          </div>
        </div>
        <!-- non equipment end -->

        <!-- if equipment -->
        <div class="grid nested-grid ml-4">
          <div class="formgrid grid" v-for="(item, index) in equipmentPartsArr" :key="index">
            <div class="field col-1">
              <label class="font-semibold">Part<span class="text-red-500">*</span></label>
              <div>
                <InputText class="w-full" v-model="item.part" placeholder="Enter part name"></InputText>
              </div>
            </div>
            <div class="field col-1 ">
              <label class="font-semibold">HSN</label>
              <div>
                <InputText class="w-full" v-model="item.hsn" placeholder="HSN/SAC code"></InputText>
              </div>
            </div>
            
            <div class="field col-1">
              <label class="font-semibold">Model</label>
              <div>
                <InputText class="w-full" v-model="item.model" placeholder="Model No."></InputText>
              </div>
            </div>
            <div class="field col-1">
              <label class="font-semibold">Part/Sr No.</label>
              <div>
                <InputText class="w-full" v-model="item.serial" placeholder="Part or Serial No."></InputText>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Quantity<span class="text-red-500">*</span></label>
              <div>
                <InputNumber  v-model="item.quantity" @update:modelValue="setPartValue(index)"></InputNumber>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Rate</label>
              <div>
                <InputNumber  v-model="item.rate" :minFractionDigits="2" :maxFractionDigits="2" @update:modelValue="setPartValue(index)"></InputNumber>
                <small id="equip-x-gst-help" class="font-semibold">Ex-GST:{{ item.exGst }}</small>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">GST(%)</label>
              <div>
                <InputNumber  v-model="item.gstRate" :minFractionDigits="2" :maxFractionDigits="2" @update:modelValue="setPartValue(index)"></InputNumber>
                <small id="equip-gst-help" class="font-semibold">GST:{{ item.gst }}</small>
              </div>
            </div>
            
            <div class="field col">
              <label class="font-semibold">Disc(%)</label>
              <div>
                <InputNumber  v-model="item.discRate" :minFractionDigits="2" :maxFractionDigits="2" @update:modelValue="setPartValue(index)"></InputNumber>
                <small id="equip-gst-help" class="font-semibold">Disc:{{ item.discAmt }}</small>
              </div>
            </div>
            <div class="field col">
              <label class="font-semibold">Subtotal</label>
              <div>
                <label >{{ item.subtotal }}</label>
              </div>
            </div>
            <div class="field col">
              <div>
                <Button icon="pi pi-trash" severity="danger" raised text @click="removePart(index)"></Button>
              </div>
            </div>

          </div>
        </div>
        <!-- if equipment end -->

      </div>
  </div>

  <template #footer>
        <div class="flex justify-content-end flex-wrap">
          <Button label="Add" size="small" raised @click="bindData"/>
          <Button class="ml-2" label="Close" raised text severity="danger" size="small" @click="closeDialog"/>
        </div>
    </template> 
</Dialog>
</template>

<script>
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';

export default {
  name: "InvoiceItem",
  
  props:{
    item:Object,
    visible:Boolean,
  },
  
  components:{
    InputText,
    Button,
    InputNumber,
    Calendar,
    Dialog,
    Divider,    
  },
  data(){
    return{
      invoiceItem:this.item,
      visibility:this.visible,
      itemName:this.item.item_name,
      itemQty:this.item.quantity,
      itemHsn:null,
      recdQty:0,
      itemRate:0,
      itemGstRate:0,
      // itemGst:0,
      // itemExGst:0,
      // itemTotal:0,
      itemDiscRate:0,
      // itemDiscAmt:0,
      batchArr:[],
      equipmentPartsArr:[],
      itemModelNo:null,
      itemPartSerialNo:null,
      itemBatchQty:0,
      itemBatch:null,
      itemBatchMfg:null,
      itemBatchExp:null,
      equipPartName:null,
      equipPartQty:0,
      equipPartHsn:null,
      equipPartSerialNo:null,
      equipPartRate:0,
      equipPartExGst:0,
      equipPartGstRate:0,
      equipPartGst:0,
      equipPartSubtotal:0,
      partPresent:false,
      itemPacking:null,
    }
  },
  mounted(){    
    this.itemName = this.item.item_name;
    this.itemQty = this.item.quantity;
    this.itemRate = this.item.rate;
    this.itemGstRate = this.item.gst;
  },
  computed:{
    itemExGst(){
      return this.roundOffTwoDecimal((this.recdQty * this.itemRate) - this.itemDiscAmt); 
    },
    itemGst(){
      return this.roundOffTwoDecimal(this.itemExGst  * (this.itemGstRate/100));
    },
    itemDiscAmt(){
      return this.roundOffTwoDecimal((this.recdQty * this.itemRate) * (this.itemDiscRate/100));
    },
    itemTotal(){
      return this.roundOffTwoDecimal(this.itemExGst + this.itemGst);
    },

  },
  methods:{
    addPart(){
      // this.partPresent = true;
      this.equipmentPartsArr.push({
        part:null,
        hsn:null,
        model:null,
        serial:null,
        quantity:0,
        rate:0,
        gstRate:0,
        exGst:0,
        gst:0,
        discRate:0,
        discAmt:0,
        subtotal:0,
      });
    },
    removePart(index){
      this.equipmentPartsArr.splice(index, 1);
      if(this.equipmentPartsArr.length==0){
        this.partPresent = false;
      }
    },
    addBatch(){

      if(this.itemRate==0 || this.itemRate==null || this.itemGstRate==0 || this.itemGstRate===null){
        return this.showErrorToast({message:'Please enter rate and GST rate before adding batch!'});
      }

      this.batchArr.push({
        quantity:0,
        batch:null,
        mfg:null,
        exp:null,
        rate:this.itemRate,
        exGst:0,
        gst:0,
        gstRate:this.itemGstRate,
        discPerc:this.itemDiscRate,
        discAmt:0,
        subTotal:0,
      });
    },
    removeBatch(index){
      this.batchArr.splice(index, 1);
    },
    bindData(){

      // if(this.recdQty > this.item.arrived.quantity){
      //   return this.showErrorToast({message:'Received quantity cannot be greater than dispatched quantity!'});
      // }
      if(this.itemHsn==null){
        return this.showErrorToast({message:'HSN is required!'});
      }

      if(this.itemPacking==null || this.itemPacking=='' || this.recdQty==0 || this.recdQty==null){
        return this.showErrorToast({message:'Fields marked with * are mandatory!'});
      }

      let data = null; 
      
      if(this.invoiceItem.category=='Equipment' || this.invoiceItem.category=='EQUIPMENT'){

        data = {
          'stockArrId':this.invoiceItem.arrived.stockArrId,
          'itemId':this.invoiceItem.id,
          'name':this.itemName,
          'itemHsn':this.itemHsn,
          'packing':this.itemPacking,
          'itemPackQty':this.recdQty,
          'batchNo':this.itemBatch,
          'modelNo':this.itemModelNo,
          'mfgDate':null,
          'expDate':null,
          'partNo':this.itemPartSerialNo,
          'itemRate':this.itemRate,
          'amount':this.itemExGst,
          'subTotal':this.itemTotal,
          'gstPerc':this.itemGstRate,
          'gstAmt':this.itemGst,
          'discPerc':this.itemDiscRate,
          'discAmt':this.itemDiscAmt,
          'equipmentPartsArr':this.equipmentPartsArr.length>0 ? this.equipmentPartsArr : [],
          'batchArr':[],
        }

        
        // temporarily disabled as need to change structure of saving equipment parts

        // if(this.equipmentPartsArr.length>0){
        // let totalValue = 0;

        //   this.equipmentPartsArr.forEach((e)=>{
        //     totalValue += e.subtotal;
        //   });          

        //   if(totalValue!=this.itemTotal){
        //     return this.showErrorToast({message:'Equipment parts total does not match item total!'});
        //   }          
        // }
        
      }
      else{
        if(this.batchArr.length==0){
          return this.showErrorToast({message:'Add atleast One(1) blank batch!'})
        }
        data = {
          'stockArrId':this.invoiceItem.arrived.stockArrId,
          'itemId':this.invoiceItem.id,
          'name':this.itemName,
          'itemHsn':this.itemHsn,
          'packing':this.itemPacking,
          'itemPackQty':this.recdQty,
          'batchNo':this.itemBatch,
          'modelNo':this.itemModelNo,
          'partNo':this.itemPartSerialNo,
          'itemRate':this.itemRate,
          'amount':this.itemExGst,
          'subTotal':this.itemTotal,
          'gstPerc':this.itemGstRate,
          'gstAmt':this.itemGst,
          'discPerc':this.itemDiscRate,
          'discAmt':this.itemDiscAmt,
          'equipmentPartsArr':[],
          'batchArr':this.batchArr.length>0 ? this.batchArr.map((e)=>{
            e.mfg = ((e.mfg instanceof Date) && !isNaN(e.mfg)) ? e.mfg.getDate()+'-'+(e.mfg.getMonth()+1)+'-'+e.mfg.getFullYear() : e.mfg;
            e.exp = ((e.exp instanceof Date) && !isNaN(e.exp)) ? e.exp.getDate()+'-'+(e.exp.getMonth()+1)+'-'+e.exp.getFullYear() : e.exp;
            return e;
          }) : [],
        }
        let totalQty = 0;
        if(this.batchArr.length>0){
          this.batchArr.forEach((e) => {
            totalQty += e.quantity;
          });
  
          if(totalQty>this.recdQty || totalQty<this.recdQty){
            return this.showErrorToast({message:'Batch quantities do not match receive quantity!'});
          }
        }
      }

      this.visibility = false;
      this.$emit('save-item', data);
      
    },     
    setRecdQty(event){
      this.recdQty = event.value;
    },
    setRate(event){
      this.itemRate = event.value;
    },
    setGst(event){
      this.itemGstRate = event.value;
    },
    setDiscount(event){
      this.itemDiscRate = event.value;
    },
    setPartValue(index){
      
      const item = this.equipmentPartsArr[index];
      item.exGst = this.roundOffTwoDecimal(item.quantity * item.rate);
      item.discAmt = this.roundOffTwoDecimal(item.exGst * (item.discRate/100));
      item.exGst -= item.discAmt;
      item.gst = this.roundOffTwoDecimal(item.exGst * (((100+item.gstRate)/100)-1));
      item.subtotal = this.roundOffTwoDecimal(item.exGst + item.gst);
      // item.subtotal = this.roundOffTwoDecimal(item.subtotal - item.discAmt);
      this.equipmentPartsArr[index] = {...item};
    },
    batchValue(index){
      const item = this.batchArr[index];
      item.exGst = item.quantity * item.rate;
      item.discAmt = this.roundOffTwoDecimal(item.exGst * (item.discPerc/100));
      item.exGst -= item.discAmt;
      item.gst = this.roundOffTwoDecimal(item.exGst * (((100+item.gstRate)/100)-1));
      item.subTotal = this.roundOffTwoDecimal(item.exGst + item.gst);
      // item.subTotal = this.roundOffTwoDecimal(item.subTotal - item.discAmt);      
    },
    closeDialog(){
      this.visibility = false;
      this.$emit('close-dialog', false, this.invoiceItem.id);
    },
    showErrorToast(error){
      this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 3000 });
    },
    roundOffTwoDecimal(value){
      return Math.round(value*100)/100;
    }
  }
}
</script>

<style>

</style>